module.exports = __webpack_public_path__ + "static/mockup-login-b13269d83f644e8d556143bc28dec785.png";